import React from 'react'

interface ButtonGroupProps {
  onCancel?: () => void
  onSubmit?: () => void
  cancelLabel?: string
  submitLabel?: string
  isDisabled?: boolean
  cancelDisabled?: boolean
  submitDisabled?: boolean
  containerClassName?: string
  cancelClassName?: string
  submitClassName?: string
}

const ButtonGroup: React.FC<ButtonGroupProps> = ({
  onCancel,
  onSubmit,
  cancelLabel = 'Cancel',
  submitLabel = 'Submit',
  isDisabled = false,
  cancelDisabled = false,
  submitDisabled = false,
  containerClassName = 'flex gap-3 justify-start',
  cancelClassName = '',
  submitClassName = '',
}) => {
  return (
    <div className={containerClassName}>
      <button type="button"
        className={`button -secondary disabled:opacity-50 disabled:cursor-not-allowed ${cancelClassName}`}
        onClick={onCancel}
        disabled={isDisabled || cancelDisabled}
      >
        {cancelLabel}
      </button>
      <button type="button"
        className={`button -primary -light mt-0! disabled:opacity-50 disabled:cursor-not-allowed ${submitClassName}`}
        onClick={onSubmit}
        disabled={isDisabled || submitDisabled}
      >
        {submitLabel}
      </button>
    </div>
  )
}

export default ButtonGroup
